export const resourceHeight = (numOfItems, totalCol, ratio) => {
    return(((totalCol / numOfItems) / totalCol) * ratio) * 100
}
